import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

// Extract the base path segment, e.g. "/outfits/123" -> "/outfits"
function getBasePath(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  return segments.length > 0 ? `/${segments[0]}` : '/';
}

export function ScrollToTop() {
  const { pathname } = useLocation();
  const prevBasePath = useRef(getBasePath(pathname));

  useEffect(() => {
    const currentBasePath = getBasePath(pathname);

    console.log('currentBasePath', currentBasePath);
    console.log('prevBasePath', prevBasePath.current);

    // Only scroll to top when the base route actually changes
    if (currentBasePath !== prevBasePath.current && currentBasePath !== '/item' && currentBasePath !== '/'
      || (currentBasePath === '/' && prevBasePath.current !== '/item')) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' as ScrollBehavior,
      });
    }

    prevBasePath.current = currentBasePath;
  }, [pathname]);

  return null;
}

export default ScrollToTop;

